import { memo } from 'react';
import type { IconButtonProps as MuiIconButtonProps } from '@mui/material';
import { IconButton as MuiIconButton, styled } from '@mui/material';

type CustomIconButtonProps = Omit<MuiIconButtonProps, 'size'> & {
  size?: number;
  className?: string;
};

const CustomIconButton = styled(({ size, ...props }: CustomIconButtonProps) => <MuiIconButton {...props} />, {
  shouldForwardProp: (prop) => prop !== 'size',
})(({ size = 40, theme }) => ({
  width: `${size}px`,
  height: `${size}px`,
  color: theme?.palette.text.primary,
  '&.Mui-disabled': {
    color: theme.palette.text.disabled,
    '&  > span > .MuiSvgIcon-root': {
      color: `${theme.palette.text.disabled} !important`,
    },
    '&  > .MuiSvgIcon-root': {
      color: `${theme.palette.text.disabled} !important`,
    },
  },
}));

export const IconButton = memo(({ children, size, className, ...rest }: CustomIconButtonProps) => {
  return (
    <CustomIconButton size={size} className={className} {...rest}>
      {children}
    </CustomIconButton>
  );
});
